export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4850.adcaf506.jpg";